import axiosInstance from "./axiosInstance";

export const postFormRequest = async <TResponse>(
  endpoint: string,
  formData: FormData
): Promise<TResponse> => {
  // ÖNEMLİ: JSON default header’ını ez
  const res = await axiosInstance.post<TResponse>(endpoint, formData, {
    headers: {
      // undefined => axios tarayıcıda boundary’i kendisi set eder
      "Content-Type": undefined as unknown as string,
    },
    // timeout vb. gerekiyorsa buraya eklenebilir
  });
  return res.data;
};
